export default __webpack_public_path__ + "static/media/invoiceContentHeader.a8966ca1.png";